<template>
  <div class="text-center mb-4">
    <img
      src="../assets/img/coat-of-arms-of-georgia-sm.png"
      class="me-4"
      style="height: 75px; width: auto"
      alt=""
    />
    <img
      src="../assets/img/open-society-georgia-oundation-sm.png"
      style="height: 75px; width: auto"
      alt=""
    />
  </div>
  <div class="text-center mb-5">
    <h4 class="fw-bold mb-2 font-caps">
      ძირითადი საკითხები თანასწორობის უფლების შესახებ
    </h4>
    <p>
      ელექტრონული კურსი ადგილობრივი ხელისუფლების ორგანოების
      წარმომადგენლებისათვის
    </p>
  </div>
  <div class="text-center small">
    <p>
      მადლობას გიხდით, რომ დაინტერესდით ელექტრონული კურსით თანასწორობის უფლების
      შესახებ.
    </p>
    <p>
      კურსი მიზნად ისახავს აამაღლოს ცნობიერება თანასწორობის უფლებისა და
      დისკრიმინაციის აკრძალვის შესახებ და დაეხმაროს ადგილობრივი ხელისუფლების
      ორგანოებში არჩეულ თუ დასაქმებულ პირებს თანასწორობის არსის აღქმაში,
      დისკრიმინაციის სხვადასხვა ფორმის გამოვლენაში, აღმოფხვრასა და თავიდან
      არიდებაში.
    </p>
    <p>ვიმედოვნებთ, რომ თქვენთვის საინტერესო იქნება შემოთავაზებული მოდულები.</p>
    <p>ელექტრონული კურსი თანასწორობის უფლების ძირითადი საკითხების შესახებ, მომზადდა საქართველოს სახალხო დამცველისა და ფონდ „ღია საზოგადოება საქართველოს“ ერთობლივი ძალისხმევით.</p>
    <p class="mb-0">ავტორი: მარიეტა ახვლედიანი</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>